import { InjectionToken } from "@angular/core";
import { LocalStorageOptions } from "./local-storage.module";

export const LOCAL_STORAGE_OPTIONS = new InjectionToken<LocalStorageOptions>(
  "LOCAL_STORAGE_OPTIONS"
);
